export const SET_MODAL_PROFILE = 'SET_MODAL_PROFILE';
export const CLEAR_MODAL_PROFILE = 'CLEAR_MODAL_PROFILE';
